// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_views_pages_map_map_routes_ts":"873e71a44c746cfa","src_app_views_pages_immersive_immersive_routes_ts":"c548850242501253","src_app_views_pages_profile_profile_routes_ts":"cd006fe1cd947913"}[chunkId] + ".js";
};